export enum DeliveryDatePresetEnum {
	STANDARD = 'standard',
	SPOT = 'spot',
	DATE = 'date',
}
